{
  "errors": {
    "noBulletins": "No bulletins available",
    "bulletinsFetchError": "Error occurred while fetching bulletins",
    "errorLoadingBulletin": "Error loading bulletin. Please try again later."
  },
  "edited": "Edited"
}
